<template>
  <div
    v-if="isLessonEmpty"
    class="btn btn-primary bg-white tasklist tasklist__name--blocked"
  >
    <div class="tasklist__firstrow">
      <div
        :class="{
          'bg-grey-task': homework.status === 0 || homework.status === undefined,
          'bg-blue': homework.status === 1,
          'bg-blue-lighter': homework.status === 2,
          'bg-pink-light': homework.status === 3,
        }"
        class="tasklist__status"
      >
        <img v-if="homework.status === 0 || homework?.status === undefined" src="@/assets/images/icons/i_homework-status-not-checked.svg" alt="Status" />
        <img v-if="homework.status === 1" src="@/assets/images/icons/i_homework-status-checked.svg" alt="Status" />
        <img v-if="homework.status === 2" src="@/assets/images/icons/i_homework-status-partly-checked.svg" alt="Status" />
        <img v-if="homework.status === 3" src="@/assets/images/icons/i_homework-status-unfinished.svg" alt="Status" />
      </div>
      <div class="tasklist__date">
        <span>Na kiedy?</span>
        <span>{{ formattedDate }}</span>
      </div>
    </div>
    <span v-if="formattedTaskTitle" class="tasklist__name">{{ formattedTaskTitle }}</span>
  </div>
  <router-link
    v-else
    :to="{ name: 'Main.HomeworksDetails', params: { id: homework.lesson.id }}"
    class="btn btn-primary bg-white tasklist"
  >
    <div class="tasklist__firstrow">
      <div
        :class="{
          'bg-grey-task': homework.status === 0 || homework.status === undefined,
          'bg-blue': homework.status === 1,
          'bg-blue-lighter': homework.status === 2,
          'bg-pink-light': homework.status === 3,
        }"
        class="tasklist__status"
      >
      <img v-if="homework.status === 0 || homework?.status === undefined" src="@/assets/images/icons/i_homework-status-not-checked.svg" alt="Status" />
      <img v-if="homework.status === 1" src="@/assets/images/icons/i_homework-status-checked.svg" alt="Status" />
        <img v-if="homework.status === 2" src="@/assets/images/icons/i_homework-status-partly-checked.svg" alt="Status" />
        <img v-if="homework.status === 3" src="@/assets/images/icons/i_homework-status-unfinished.svg" alt="Status" />
      </div>
      <div class="tasklist__date">
        <span>Na kiedy?</span>
        <span>{{ formattedDate }}</span>
      </div>
    </div>
    <span v-if="formattedTaskTitle" class="tasklist__name" :class="{ 'tasklist__link': subjectHasUrl }">
      {{ formattedTaskTitle }}
    </span>
    <Button class="btn_primary">Szczegóły</Button>
  </router-link>
</template>

<script>
import moment from 'moment';
import Button from '@/components/Form/BaseButton.vue';

export default {
  name: 'TaskList',

  props: {
    homework: Object,
  },

  components: {
    Button,
  },

  computed: {
    formattedDate() {
      return moment(this.homework.lesson.date).format('DD.MM');
    },

    formattedTaskTitle() {
      if (this.homework.lesson) {
        const title = this.homework.lesson.homeworkSubject;
        const titleWithoutUrl = title.slice(0, 100);
        // commented temporary
        // const isTitleWithoutSubject = title.startsWith('https');

        if (!title) {
          return this.$t('dashboard.subject_not_found');
        }
        // if (isTitleWithoutSubject) {
        //   return this.$t('dashboard.subject_empty');
        // }
        return titleWithoutUrl;
      }
      return null;
    },

    isLessonEmpty() {
      return !this.homework.lesson.homeworkSubject;
    },

    subjectHasUrl() {
      return this.homework.lesson.homeworkSubject.includes('https');
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  @apply no-underline;
}
.tasklist {
  @apply flex flex-col items-start py-8 px-6 cursor-pointer overflow-hidden;
  row-gap: 24px;
  border-radius: 8px;
  margin-bottom: 11px;
  animation: fadeIn 0.2s cubic-bezier(0.56, 0.33, 0.54, 0.95) 0.3s both;
  @media screen and (min-width: 992px) {
    @apply flex-row items-center p-6;
    column-gap: 24px;
  }
  &__firstrow {
    @apply flex flex-row;
    column-gap: 24px;
  }
  &__date {
    @apply flex flex-col justify-center text-sm;
    row-gap: 4px;
    line-height: 16px;
    @media screen and (min-width: 992px) {
      @apply text-xs;
      row-gap: 2px;
      line-height: 14px;
    }
    span {
      font-weight: 400;
      &:last-child {
        font-weight: 600;
      }
    }
  }
  &__name {
    @apply flex-1 flex items-center text-lg;
    line-height: 1.25;
    @media screen and (min-width: 992px) {
      @apply text-lg;
    }
    &--blocked {
      @apply cursor-not-allowed;
    }
  }
  &__link {
    word-break: break-word;
  }
  &__status {
    @apply flex justify-center items-center text-white rounded-lg text-xs text-center;
    width: 38px;
    height: 38px;
  }
  .btn_primary {
    @apply bg-white text-pink-main text-sm p-0;
    border: 1px solid #ec268f;
    width: 100px;
    height: 36px;
    &:hover {
      @apply bg-pink-main text-white;
    }
  }
}
</style>
